import React, { useEffect, useState } from 'react';
import './MarketTabScreen.css';

// Універсальний екран маркету зі світлою темою:
// - pageTitle — маленький заголовок по центру (напр. «Кабінет»);
// - heading   — великий заголовок зліва (напр. «Ваш кошик»);
// - tabs       — сегмент-контрол на 2 таби [{ label, title, subtitle? }];
// - empty      — порожній стан для екрана без табів { title, subtitle? }.
// Центр — тимчасово фото 1.png (замість котика).
const MarketTabScreen = ({ pageTitle, heading, tabs, empty }) => {
  const [active, setActive] = useState(0);

  // Екрани маркету світлі — робимо body білим (safe-area знизу теж білою),
  // повертаємо попередній фон при виході.
  useEffect(() => {
    const original = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#ffffff';
    return () => { document.body.style.backgroundColor = original; };
  }, []);

  const panel = tabs ? (tabs[active] || {}) : (empty || {});

  return (
    <div className="market-tab-page">
      {heading && <h1 className="market-tab-heading">{heading}</h1>}
      {pageTitle && <h1 className="market-tab-title">{pageTitle}</h1>}

      {tabs && (
        <div className="market-segmented">
          {tabs.map((t, i) => (
            <button
              key={t.label}
              type="button"
              className={`market-seg ${active === i ? 'active' : ''}`}
              onClick={() => setActive(i)}
            >
              {t.label}
            </button>
          ))}
        </div>
      )}

      <div className="market-empty">
        <img className="market-empty-img" src="/market-icons/1.png" alt="" />
        <p className="market-empty-title">{panel.title}</p>
        {panel.subtitle && <p className="market-empty-sub">{panel.subtitle}</p>}
      </div>
    </div>
  );
};

export default MarketTabScreen;
